import React from 'react';
import { Player, Specialization, LEVELS } from '../types';
import { SpecializationSelector } from './SpecializationSelector';

interface PlayerRowProps {
  player: Player;
  specializations: Specialization[];
  onPlayerUpdate: (playerId: string, updatedPlayer: Player) => void;
  onPlayerDelete: (playerId: string) => void;
  getSpecializationsForLevel: (level: number) => Specialization[];
}

export const PlayerRow: React.FC<PlayerRowProps> = ({
  player,
  specializations,
  onPlayerUpdate,
  onPlayerDelete,
  getSpecializationsForLevel
}) => {
  const handleNameChange = (name: string) => {
    onPlayerUpdate(player.id, { ...player, name });
  };

  const handleChoiceUpdate = (level: number, selectedSpecs: string[], chosenSpec?: string) => {
    const updatedChoices = {
      ...player.choices,
      [level]: {
        playerId: player.id,
        level,
        availableSpecs: selectedSpecs,
        chosenSpec
      }
    };
    
    onPlayerUpdate(player.id, { ...player, choices: updatedChoices });
  };

  return (
    <tr className="border-b hover:bg-gray-50">
      {/* Player Name */}
      <td className="p-3 border-r sticky left-0 bg-white z-10">
        <div className="flex items-center gap-2">
          <input
            type="text"
            value={player.name}
            onChange={(e) => handleNameChange(e.target.value)}
            className="flex-1 p-2 border rounded-md"
            placeholder="Player name..."
          />
          <button
            onClick={() => onPlayerDelete(player.id)}
            className="text-red-600 hover:text-red-800 px-2 py-1 rounded hover:bg-red-100"
            title="Delete player"
          >
            ×
          </button>
        </div>
      </td>

      {/* Level Columns */}
      {LEVELS.map((level) => {
        const choice = player.choices[level];
        const availableSpecs = getSpecializationsForLevel(level);
        
        return (
          <td key={level} className="p-2 border-r min-w-[200px]">
            <SpecializationSelector
              specializations={availableSpecs}
              selectedSpecs={choice?.availableSpecs || []}
              chosenSpec={choice?.chosenSpec}
              onChange={(selectedSpecs, chosenSpec) => 
                handleChoiceUpdate(level, selectedSpecs, chosenSpec)
              }
              level={level}
            />
          </td>
        );
      })}
    </tr>
  );
};